import { isFinished } from "~/modules/calls/utils"
import { PluginReviewActionNotAllowedError } from "~/lib/AjaxCtx"

export function makeActions(service) {
    return {
        async "connector/start"({ state, commit }, { userActivityId }) {
            const activity = state.userActivities[userActivityId]
            if (!shouldTrace(activity)) return

            const { sessionId } = await service.start(userActivityId)
            commit("setLocalState", {
                userActivityId,
                localState: {
                    sessionId,
                },
            })
            return sessionId
        },

        async "connector/end"(
            { state, dispatch },
            { userActivityId, isClosing, sessionId }
        ) {
            const activity = state.userActivities[userActivityId]
            if (!shouldTrace(activity)) return

            if (!sessionId) {
                // No session was started for this connector
                return
            }

            try {
                await service.end({ userActivityId, sessionId, isClosing })
            } catch (error) {
                if (error instanceof PluginReviewActionNotAllowedError) {
                    dispatch("lms/refreshUserActivity", userActivityId, {
                        root: true,
                    })
                    return
                }
                throw error
            }
        },
    }
}

function shouldTrace(activity) {
    if (!activity) {
        //There is no activity
        return false
    }
    const activityIsFinished = isFinished(activity)
    return activity.configuration.tracing && !activityIsFinished
}

export default {
    makeActions,
}
